import React from 'react';
import { appNamedRoutes } from 'routes';
import PageSubNav from 'components/nav/PageSubNav';

const COMMUNICATION_PAGES = [
  {
    path: appNamedRoutes.communicationIndividuals,
    label: 'Individuals',
  },
  {
    path: appNamedRoutes.communicationGroups,
    label: 'Groups',
  },
];

const CommunicationSubNav = () => {
  return (
    <PageSubNav items={COMMUNICATION_PAGES} />
  );
};

export default CommunicationSubNav;
